import { render, staticRenderFns } from "./InvestementDetails.vue?vue&type=template&id=5d06feaa&scoped=true&"
import script from "./InvestementDetails.vue?vue&type=script&lang=js&"
export * from "./InvestementDetails.vue?vue&type=script&lang=js&"
import style0 from "./InvestementDetails.vue?vue&type=style&index=0&id=5d06feaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d06feaa",
  null
  
)

export default component.exports